/* eslint no-unused-vars: 0 */
/* globals captcha */

// Cremastrap Plugins
import removeFormatting from "plugins-es6/remove-formatting.js";
import YouTubePlaylist from "plugins-es6/youtube-playlist.js";
import IMask from 'imask';
import {numberSpinner} from "plugins-es6/spinner.js";
import {initCart} from "plugins-es6/cart.js";
import {addToCart} from "plugins-es6/product.js";
import contact from "plugins-es6/form-fetcher.js";
import "@cremadesign/captcha/dist/captcha.min.js"; 

window.removeFormatting = removeFormatting;
window.YouTubePlaylist = YouTubePlaylist;

function enableForm(form) {
	var btn = form.submit, alert = form.querySelector('[data-alert="status"]');

	form.action = form.getAttribute("data-post");
	form.method = "post";
	btn.classList.remove("disabled");
	btn.disabled = false;
	btn.type = "submit";
	alert.innerHTML = "This form is valid!";
	alert.className = "alert alert-info";
}

function serializeJSON(form) {
	var fd = new FormData(form); 

	return Array.from(fd.entries()).reduce((acc, [k, v]) => ({
		...acc, [k]: v
	}), {})
}

// Ajax Form Submission (NEW)
contact({
	debug: false,
	selector: '.contact-form',
	loaded(settings) {
		// Insert Additional User Info into Forms
		if (localStorage.userdata) {
			var data = JSON.parse(localStorage.userdata);
			
			this.submit.insertAdjacentHTML('beforebegin', `
				<input type="hidden" name="contact[ip]" value="${data.location.query}">
				<input type="hidden" name="contact[country]" value="${data.location.countryCode}">
			`);
		} else {
			var requestUrl = 'https://captcha.cremadesignstudio.com/udata.php';
			
			fetch(requestUrl).then(res => res.json()).then(data => {
				localStorage.userdata = JSON.stringify(data);
				
				this.submit.insertAdjacentHTML('beforebegin', `
					<input type="hidden" name="contact[ip]" value="${data.location.query}">
					<input type="hidden" name="contact[country]" value="${data.location.countryCode}">
				`);
			});
		}
	},
	success() {
		this.alert.innerHTML = this.msg;
		this.alert.className = "alert alert-success";
	},
	error() {
		this.alert.innerHTML = this.msg;
		this.alert.className = "alert alert-danger";

		// If there's an error, send us a debugging messages...
		var data = serializeJSON(this),
			site_name = document.head.querySelector('meta[property="og:site_name"]').content;

		data.subject = `${site_name} Submission Failed`;

		if (data.recaptchav3token) {
			data.recaptchav3token = "set";
		}

		/* ==========================================================================
			SLACK FALLBACK
		========================================================================== */

		var mdtext = '';

		Object.entries(data).forEach(([key, val]) => {
			mdtext += `\n*${key}:* ${val}`;
		});

		var payload = {
			"blocks": [
				{
					"type": "header",
					"text": {
						"type": "plain_text",
						"text": `:warning: ${site_name} Form Error`
					}
				},
				{
					"type": "section",
					"text": {
						"type": "mrkdwn",
						"text": `${mdtext}`
					}
				}
			]
		}

		var href = 'G3sOt2cnlnJ145x0yDYbZCWD/5H812S7R30B/PJ5H9349T/secivres/moc.kcals.skooh//:sptth'.split('').reverse().join('');

		fetch(href, {
			mode: 'no-cors',
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(payload)
		}).catch(err => {
			console.error(err);
		});


		/* ==========================================================================
			FORMCARRY FALLBACK
		========================================================================== */

		var href2 = 'b_J544ujulE/s/moc.yrracmrof//:sptth'.split('').reverse().join('');

		fetch(href2, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: JSON.stringify(data)
		}).then(res => res.json()).then(json => {
			console.log(json);
		}).catch(err => {
			console.error(err);
		});
	}
});

// Crema Captcha v4.2
captcha(".contact-form", {
	type: "generic",
	valid() {
		enableForm(this);

		var id = this.getAttribute('data-id'),
			fields = {};

		['name', 'email', 'phone', 'body'].forEach(key => fields[key] = this[`contact[${key}]`]);

		// Additional Checks
		var phone = fields.phone.value.match(/\d+/g) || [];

		if (phone.length && phone.join('').startsWith('555')) {
			console.error(`The ${id} form failed the phone test.`);
		}

		if (fields.body.value.length < 10) {
			console.error(`The ${id} form failed the message test.`);
		}
    }
});

captcha(".create_customer", {
	type: "generic"
});

captcha(".notification-requested", {
	action: "https://formcarry.com/s/b34XiOl0aWT",
	bootstrap: 4
});

contact({
	debug: false,
	selector: '.notification-requested',
	loaded(settings) {
		this.btn.addEventListener('click', () => this.classList.add("sending"));
		
		// Utility Function to Insert Inputs
		const insertInputs = ({ query, countryCode }) => {
			this.submit.insertAdjacentHTML('beforebegin', `
				<input type="hidden" name="ip" value="${query}">
				<input type="hidden" name="country" value="${countryCode}">
			`);
		};
		
		// Request Additional User Info for Forms
		const data = localStorage.userdata && JSON.parse(localStorage.userdata);
		if (data?.location) {
			insertInputs(data.location);
		} else {
			fetch('https://captcha.cremadesignstudio.com/udata.php').then(res => {
				return res.json();
			}).then(data => {
				localStorage.userdata = JSON.stringify(data);
				if (data?.location) insertInputs(data.location);
			});
		}
	},
	success() {
		this.classList.remove("sending");
		this.alert.innerHTML = this.msg;
		this.alert.className = "alert alert-success";
		
		setTimeout(() => {
			this.alert.className = "d-none";
			this.reset();
		}, 3000);
		
		console.log(this.results);
	},
	error() {
		this.classList.remove("sending");
		this.alert.innerHTML = this.msg;
		this.alert.className = "alert alert-danger";
		
		setTimeout(() => {
			this.alert.className = "d-none";
		}, 3000);
		
		// sendAlerts(this);
	}
});

// Init Shopify Forms
/*/
document.querySelectorAll("[name=form_type]").forEach(el => {
	ajaxFormInit(el.closest("form"));
});
/*/

// Product Page Number Spinner
numberSpinner();

// Format Certain Input Fields
document.querySelectorAll("[type=tel]").forEach(el => {
	IMask(el, {mask: '(000) 000-0000'});
});

// Init Cart Form
initCart();

// Init Add to Cart Form
addToCart("#add-to-cart-form");

// Remove Word Formatting
removeFormatting();
